import { articleImages } from "./images";

export interface ArticleMeta {
  slug: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  { slug: "allchinabuy-spreadsheet-guide", image: articleImages["allchinabuy-spreadsheet-guide"] },
  { slug: "allchinabuy-finds", image: articleImages["allchinabuy-finds"] },
  { slug: "allchinabuy-qc-guide", image: articleImages["allchinabuy-qc-guide"] },
  { slug: "allchinabuy-shipping-cost", image: articleImages["allchinabuy-shipping-cost"] },
  { slug: "allchinabuy-warehouse", image: articleImages["allchinabuy-warehouse"] },
  { slug: "allchinabuy-review", image: articleImages["allchinabuy-review"] },
  { slug: "allchinabuy-legit", image: articleImages["allchinabuy-legit"] },
  { slug: "allchinabuy-coupon", image: articleImages["allchinabuy-coupon"] },
  { slug: "allchinabuy-buying-guide", image: articleImages["allchinabuy-buying-guide"] },
  { slug: "how-to-use-allchinabuy", image: articleImages["how-to-use-allchinabuy"] },
  { slug: "allchinabuy-vs-superbuy", image: articleImages["allchinabuy-vs-superbuy"] },
];